import { MobileTabBar } from '../../components/MobileTabBar';
import { SideNav } from '../../components/SideNav';
import { AnnouncementBanner } from '../AnnouncementBanner';
import { AnnouncementDialog } from '../AnnouncementDialog';
import { LanguagePicker } from '../LanguagePicker';
import { MenuDrawer } from '../MenuDrawer';
import { Body, ContentArea, Main, Shell, SkipLink } from './AppShell.styles';

const MAIN_CONTENT_ID = 'main-content';
import type { AppShellProps } from './AppShell.types';

export function AppShell({
  navItems,
  bottomNavItems,
  mobileNavItems,
  children,
  footer,
  navigationLabel,
  banner,
  menu,
  languagePicker,
  announcement,
  hideNavigation = false,
  skipLinkLabel = 'Skip to main content',
}: AppShellProps) {
  return (
    <Shell data-hide-navigation={hideNavigation ? 'true' : undefined}>
      <SkipLink href={`#${MAIN_CONTENT_ID}`}>{skipLinkLabel}</SkipLink>

      <Body>
        {!hideNavigation && (
          <SideNav
            items={navItems}
            bottomItems={bottomNavItems}
            navigationLabel={navigationLabel}
          />
        )}

        <ContentArea>
          {banner && (
            <AnnouncementBanner
              heading={banner.heading}
              body={banner.body}
              dismissible={banner.dismissible}
              onDismiss={banner.onDismiss}
              closeLabel={banner.closeLabel}
              showMoreLabel={banner.showMoreLabel}
              showLessLabel={banner.showLessLabel}
            />
          )}
          <Main id={MAIN_CONTENT_ID} tabIndex={-1}>
            {children}
          </Main>
          {footer}
        </ContentArea>
      </Body>

      {!hideNavigation && <MobileTabBar items={mobileNavItems} navigationLabel={navigationLabel} />}

      {menu && (
        <MenuDrawer
          open={menu.open}
          onClose={menu.onClose}
          title={menu.title}
          closeLabel={menu.closeLabel}
          items={menu.items}
          noImageLabel={menu.noImageLabel}
          width={menu.width}
          desktopOffset={menu.desktopOffset}
          languageSelector={menu.languageSelector}
        />
      )}

      {languagePicker && (
        <LanguagePicker
          open={languagePicker.open}
          onClose={languagePicker.onClose}
          title={languagePicker.title}
          closeLabel={languagePicker.closeLabel}
          items={languagePicker.items}
        />
      )}

      {announcement && (
        <AnnouncementDialog
          open={announcement.open}
          onClose={announcement.onClose}
          heading={announcement.heading}
          body={announcement.body}
          imageUrl={announcement.imageUrl}
          validFor={announcement.validFor}
          cta={announcement.cta}
          closeLabel={announcement.closeLabel}
        />
      )}
    </Shell>
  );
}
